import { BButton, BCard } from '../ui/generic';
import axiosInstance from '../../utils/AxiosInstance';
import { useForm } from 'react-hook-form';
import { IconCheck, IconLoader2, IconUpload, IconX } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

const Single = ({ type, label, current }) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [isError, setIsError] = useState(false);
  const queryClient = useQueryClient();

  const {
    reset,
    watch,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();
  const handleAddFile = async (data) => {
    setIsSuccess(false);
    setIsError(false);
    setMessageError('');
    const file = data[`file${type}`][0];
    const formData = new FormData();
    formData.append('document', file); // only one file here
    if (type !== 'autre') formData.append('type', type); // only one file here

    const response = await axiosInstance.post('/internal_api/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (!response.data.error) {
      reset();
      setIsSuccess(true);
      queryClient.invalidateQueries(['documents']);
    } else {
      setIsError(true);
      setMessageError(response.data.message);
    }
  };
  const fileWatch = watch('file') ?? false;
  useEffect(() => {
    setIsSuccess(false);
    setIsError(false);
  }, [fileWatch]);

  const handleDeleteFile = async (e, data) => {
    e.stopPropagation();
    e.preventDefault();

    const res = await axiosInstance.post('/internal_api/documents/remove', data);
    if (res.data.error) {
      setIsError(true);
      setMessageError(res.data.message);
      toast.error(res.data.message);
    } else {
      reset();
      setIsSuccess(false);
      setIsError(false);
      setMessageError('');
      queryClient.invalidateQueries(['documents']);
    }
  };
  return (
    <form
      onChange={(e) => {
        e.preventDefault();
        handleSubmit(handleAddFile)();
      }}
    >
      <label
        htmlFor={`file${type}`}
        className="mx-auto flex h-fit w-full max-w-md cursor-pointer flex-col items-center justify-center rounded border-2 border-dashed border-slate-200 bg-white py-2 text-base text-slate-700"
      >
        {isSubmitting ? (
          <IconLoader2 className={`mb-3 w-11 animate-spin`} />
        ) : isSuccess ? (
          <IconCheck className={'mb-3 w-11 text-green-500'} />
        ) : isError ? (
          <IconX className={'mb-3 w-11 text-red-500'} />
        ) : (
          <IconUpload className={'mb-3 w-11'} />
        )}
        {current ? 'Modifier  ' : 'Déposez  '} {label}
        <p className={"text-xs"}>ou</p>
        <button
          type="button"
          className="text-xs text-blue-600 underline hover:text-blue-800 focus:ring focus:ring-blue-300 focus:outline-none"
          onClick={() => document.getElementById(`file${type}`)?.click()}
        >
          cliquez ici
        </button>
        <p className={'text-xs text-red-500'}>{messageError}</p>
        <input {...register(`file${type}`, { required: true })} type={'file'} id={`file${type}`} className="hidden" />
        {current ? (
          <div className={'flex items-center gap-2'}>
            <a
              href={import.meta.env.VITE_API_BASE_URL + '/' + current.link}
              target={'_blank'}
              className={'hover:text-primary-500 text-xs text-slate-700 hover:cursor-alias hover:underline'}
            >
              {current.name}
            </a>
            <button type={'button'} onClick={(e) => handleDeleteFile(e, current)}>
              <IconX className={'size-4 text-slate-700 hover:text-red-500'} />
            </button>
          </div>
        ) : (
          <p className={'text-xs text-slate-400'}>Aucun document</p>
        )}
      </label>
    </form>
  );
};

export default Single;
